import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Package, ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

const ProductCard = ({ product, onSelect, showAddToCart = false }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.stopPropagation();
    addToCart(product);
    toast.success(`${product.name} added to cart!`);
  };

  return (
    <Card 
      className="bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 card-hover cursor-pointer overflow-hidden"
      onClick={() => onSelect && onSelect(product)}
      data-testid={`product-card-${product.id}`}
    >
      <div className="aspect-square relative overflow-hidden bg-brand-secondary/10">
        {product.image_url ? (
          <img 
            src={product.image_url} 
            alt={product.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Package size={48} className="text-brand-muted/40" />
          </div>
        )}
        {product.is_placeholder && (
          <Badge 
            className="absolute top-3 right-3 bg-brand-coral text-white font-body text-xs"
          >
            Placeholder
          </Badge>
        )}
      </div>
      <CardContent className="p-5">
        <h3 className="font-heading text-lg text-brand-dark mb-2">{product.name}</h3>
        <p className="font-body text-sm text-brand-muted mb-3 line-clamp-2">
          {product.description}
        </p>
        <div className="flex items-center justify-between mb-3">
          <span className="font-body text-sm font-medium text-brand-coral">
            {product.price}
          </span>
          <span className="font-body text-xs text-brand-muted capitalize">
            {product.category}
          </span>
        </div>
        {showAddToCart && (
          <button
            onClick={handleAddToCart}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-full bg-brand-primary text-white font-body text-sm font-medium shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5"
            data-testid={`add-to-cart-${product.id}`}
          >
            <ShoppingCart size={16} />
            Add to Cart
          </button>
        )}
      </CardContent>
    </Card>
  );
};

export default ProductCard;
